import { createSlice } from "@reduxjs/toolkit";

import { type UserOnboardingProgressStateType } from "../interfaces/userOnboardingProgress";

const initialState: UserOnboardingProgressStateType = {
  isLoading: false,
  userOnboardingProgress: [],
};

const userOnboardingProgressSlice = createSlice({
  name: "userOnboardingProgress",
  initialState,
  reducers: {
    setUserOnboardingProgressLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setUserOnboardingProgress: (state, action) => {
      state.userOnboardingProgress = action.payload;
    },
  },
});

export const { setUserOnboardingProgressLoading, setUserOnboardingProgress } =
  userOnboardingProgressSlice.actions;
export default userOnboardingProgressSlice.reducer;
